import { Component } from '@angular/core';

@Component({
    selector: 'app-no-case-selected-overlay',
    templateUrl: './no-case-selected-overlay.component.html',
    styleUrls: ['./no-case-selected-overlay.component.scss']
})
export class NoCaseSelectedOverlayComponent {
    constructor() { }
}
